export default "__VITE_ASSET__f7ed9900__"